import { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";

import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import { authSliceReducerSlice } from "../../../../data/redux/slice/authSlice";
import {
  storeAllAcls,
  storeResponseToLocalStorage,
} from "../../../../services/loginService";
import { NeokredNewLogo } from "../../../../utility/constants/assetsManager";
import {
  bgColor,
  colorWhite,
} from "../../../../utility/constants/colorManager";
import {
  OTP_RESEND_TIME,
  STATUS_CODE_200,
} from "../../../../utility/constants/valueConstants";
import ResizeListner from "../../../../utility/ResizeListner";
import { CustomButton } from "../../../components/main_comps/custom_button";
import { CustomInput } from "../../../components/main_comps/custom_input/CustomInput";
import secureStorage from "../../../../services/secureStorage";
import { SS_AUTH_TOKEN } from "../../../../utility/constants/secureStorageManager";
import { addToAclList } from "../../../../data/redux/slice/aclSlice";
import ImageComponent from "../ImageComponent";

function OtpVerifyScreen({
  email,
  onSuccess,
  isFromForgotPass = false,
  forgotpassword = false,
  otpRefCode,
  userId,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [otpSentCount, setOtpSentCount] = useState(0);
  const { height, width } = ResizeListner();
  const [disabled, setDisabled] = useState(true);
  const [timeCount, setTimeCount] = useState(OTP_RESEND_TIME);
  const [otpResent, setOtpResent] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [emailDomain, setEmailDomain] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpRef, setOtpRef] = useState("");
  const [verified, setVerified] = useState("");

  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  // const navigate = useNavigate()

  const onClickVerifyForgotPassword = () => {
    setLoading(true);
    ApiRequestPost.forgotPasswordVerifyOtp({
      email,
      otpRefCode: otpRef,
      otp,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          onSuccess(otpRef);
          enqueueSnackbar(response.message, {
            variant: "success",
          });
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
        setLoading(false);
      });
  };

  const onClickResendOtp = () => {
    ApiRequestPost.forgotPasswordSendOtp({
      email,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          setOtpRef(response.data.otpRefCode);
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          setOtpResent(true);
          setTimeCount(OTP_RESEND_TIME);
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      });
  };
  useEffect(() => {
    let newemail = email?.split("@");
    var userEmail = newemail[0].slice(0, -3);
    var domain = newemail[1];
    setEmailDomain(domain);
    setUserEmail(userEmail);
  }, []);

  const resendOtp = () => {
    otpSentCount < 3 && onClickResendOtp();
  };

  useEffect(() => {
    if (otp.length >= 6) {
      setDisabled(false);
    } else setDisabled(true);
  }, [otp]);

  useEffect(() => {
    if (timeCount > 0) {
      setTimeout(() => {
        setTimeCount(timeCount - 1);
      }, 1000);
    } else setOtpResent(false);
  }, [timeCount]);

  useEffect(() => {
    setOtpResent(true);
  }, []);

  useEffect(() => {
    setOtpRef(otpRefCode);
  }, []);

  return (
    <div
      style={{
        width,
        display: "flex",
        flexDirection: width > 650 ? "row" : "column",
        height: height,
      }}
    >
      {/* <div
        style={{
          width: width > 650 ? "50%" : "100%",
          display: width > 650 ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: colorWhite,
        }}
      >
        <img
          src={NeokredNewLogo}
          style={{
            width: width * 0.35,
            minWidth: 150,
            maxWidth: 400,
          }}
        />
      </div> */}
      <ImageComponent />
      <div
        style={{
          width: width > 650 ? "50%" : "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: bgColor,
          flexDirection: "column",
          height,
        }}
      >
        <div
          style={{
            width: width > 650 ? "45%" : "70%",
            minWidth: width > 650 ? 300 : 250,
          }}
        >
          <p
            style={{
              fontWeight: "600",
              fontSize: 30,
              color: "#1A202C",
              margin: 0,
            }}
            className="roboto"
          >
            {isFromForgotPass ? "Verify OTP" : "Verify Email"}
          </p>
          <p
            style={{
              fontSize: 16,
              marginBottom: 30,
              color: "black",
              margin: 0,
              marginTop: 5,
              fontWeight: "400",
            }}
            className="roboto"
          >
            {forgotpassword
              ? `To reset the password Please enter the OTP shared on the ${userEmail}***@${emailDomain}`
              : `OTP has been sent to ${userEmail}***@${emailDomain}`}
          </p>

          <div style={{ marginTop: "25px" }}>
            <p
              style={{ margin: 0, color: "#4A5568", fontSize: "14px" }}
              className="roboto"
            >
              Enter OTP<span style={{ color: "#FC3629" }}>*</span>
            </p>

            <CustomInput
              type={"input"}
              value={otp}
              placeholder="1234XX"
              onChange={setOtp}
              inputStyles={{
                width: "100%",
                border: "1px solid #E8E8E8",
                boxShadow: "none",
                backgroundColor: "white",
                height: "45px",
              }}
              inputcomponentStyles={{ letterSpacing: 5 }}
              validator="otp"
              onPressEnter={() => {
                if (isFromForgotPass) onClickVerifyForgotPassword();
              }}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                width: "100%",
                marginTop: "5px",
              }}
            >
              {!otpResent ? (
                otpSentCount >= 3 ? (
                  <>
                    <p
                      style={{
                        color: "#3783FB",
                        cursor: "pointer",
                        margin: 0,
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                      className="roboto"
                    >
                      Maximun limit exceeded
                    </p>
                  </>
                ) : (
                  <p
                    style={{
                      color: "#3783FB",
                      cursor: "pointer",
                      margin: 0,
                      fontSize: "12px",
                    }}
                    onClick={resendOtp}
                    className="roboto"
                  >
                    Resend OTP
                  </p>
                )
              ) : (
                <p
                  style={{
                    color: "black",
                    margin: 0,
                    fontSize: "13px",
                    fontWeight: "400",
                  }}
                  className="roboto"
                >
                  You can request new OTP after{" "}
                  <span
                    style={{
                      fontSize: 12,
                      color: "#3783FB",
                    }}
                    className="roboto"
                  >
                    {timeCount} Seconds
                  </span>
                </p>
              )}
            </div>
          </div>
          <CustomButton
            loading={loading}
            title="Verify"
            styles={{
              width: "100%",
              borderRadius: "4px",
              marginTop: 40,
              height: "50px",
            }}
            textStyle={{
              color: colorWhite,
              fontSize: 15,
              fontWeight: 500,
            }}
            onClick={() => {
              if (isFromForgotPass) onClickVerifyForgotPassword();
            }}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
}

export default OtpVerifyScreen;
